// A tiny in-memory cache of assistant transcripts, keyed by app/chat name. It
// lets the chat view render a conversation the instant you switch to it (no
// empty-then-loaded flicker) while a fresh copy is fetched in the background,
// and lets the chats list pre-load the top few conversations so switching to
// them is instant. Lives for the page session only; never persisted.
const cache = new Map();

export const getTranscript = (name) => cache.get(name);

export const setTranscript = (name, data) => {
  cache.set(name, data);
};

// Fetch a transcript into the cache if it is not already there. Best-effort and
// silent: a failed pre-load just means that conversation loads normally later.
export const preloadTranscript = async (name) => {
  if (cache.has(name)) return;
  try {
    const r = await fetch(`/api/apps/${encodeURIComponent(name)}/assistant`, {
      credentials: "same-origin",
    });
    if (!r.ok) return;
    const data = await r.json();
    cache.set(name, {
      items: (data.items || []).map((it, idx) => ({ ...it, id: idx })),
      modes: data.modes || [],
      mode: data.mode || "",
    });
  } catch {
    // ignore; the conversation will load on demand
  }
};
